import React from 'react';

const url = `${process.env.GATSBY_SELF_URL}`;
const baseHost = url.match(/([a-zA-Z.0-9-_]+)\/?$/)[1];
const baseProtocol =
  url.match(/^([a-zA-Z]+):/) && url.match(/^([a-zA-Z]+):/)[0];

export default function HeadMaker({ seo, location: { pathname }, params }) {
  if (!pathname.endsWith('/')) {
    pathname += '/';
  }

  const canonicalHref = `${url}${pathname || ''}`;

  return (
    <>
      {seo &&
        Object.keys(seo).map((keyOfObject, index) => {
          const Tag = keyOfObject;
          const property = seo[keyOfObject];
          if (Array.isArray(property)) {
            return property.map((item, index) => {
              const ArrayTag = keyOfObject;
              // eslint-disable-next-line react/no-array-index-key
              return <ArrayTag key={`${keyOfObject}-${index}`} {...item} />;
            });
          }
          // eslint-disable-next-line react/no-array-index-key
          return <Tag key={`${keyOfObject}${index}`}>{seo[keyOfObject]}</Tag>;
        })}
      {!params['*'] && (
        <>
          <meta property="og:url" content={canonicalHref} />
          <link
            rel="canonical"
            href={canonicalHref}
            data-baseprotocol={baseProtocol}
            data-basehost={baseHost}
          />
        </>
      )}
    </>
  );
}
